export async function setFlag(flagName: string): Promise<void> {
  const formData = new FormData();
  formData.append(`flag`, flagName);
  await fetch(`/set_flag/`, {method: `POST`, body: formData});

  if (window[`mp`] && mp.report && mp.report.globals) {
    mp.report.globals.flags[flagName] = 1;
  }
}

export async function incrementFlag(flagName: string): Promise<void> {
  const formData = new FormData();
  formData.append(`flag`, flagName);
  await fetch(`/increment_flag/`, {method: `POST`, body: formData});

  if (window[`mp`] && mp.report && mp.report.globals) {
    mp.report.globals.flags[flagName] = (mp.report.globals.flags[flagName] || 0) + 1;
  }
}
